export default {
    workflows: 'Workflows',
    search: 'Search by name or workflow ID',
    'empty-list': 'No workflows has been created yet',
    'empty-filtered-list': 'No workflows found',
    'list-header': {
        name: 'Name',
        id: 'Workflow ID',
        type: 'Type',
        created: 'Created',
        revision: 'Revision',
        subflowId: 'Subflow ID',
        actions: 'Actions',
    },
    tooltip: {
        copy: 'Copy',
        run: 'Run workflow',
        params: 'Define workflow params',
        edit: 'Edit',
        delete: 'Delete',
    },
    revision: {
        label: 'Revision',
        activate: 'Activate',
        active: 'Active',
        notify: {
            selected: 'Revision {revision} has been loaded',
            activated: 'Revision {revision} is now active',
        },
    },
    'generate-link': {
        button: 'Run',
        title: 'Generated link to preview workflow "{name}"',
        'button-open': 'Open in new window',
        'button-copy-token': 'Copy token',
        'case-teaser': {
            description: 'Finish your workflow, let your dashboard light up with cases!',
        },
    },
    'define-workflow-params': {
        title: 'Define parameters for "{name}"',
        'add-param': 'Add parameter',
        'add-value': 'Add value',
        saved: 'The parameters have been successfully saved.',
        label: {
            required: 'Required',
            optional: 'Optional',
            type: 'Type',
            'item-type': 'Item type',
            validator: 'Validator',
            delete: 'Delete',
        },
        button: 'Save',
    },
    'fill-workflow-params': {
        title: 'Specify workflow parameters',
        saved: 'Workflow parameters have been successfully saved',
        button: 'Save values',
    },
    'make-copy': {
        button: 'Copy',
    },
    form: {
        name: 'Workflow name',
    },
    'create-new': {
        button: 'New Workflow',
        description: 'Start building your workflows',
        'onboarding-workflow': 'Onboarding Workflow',
        'monitoring-workflow': 'Monitoring Workflow',
    },
    'delete-confirm': {
        title: 'Are you sure you want to remove "{name}"?',
        description: 'This action cannot be undone.',
    },
    'close-builder-confirm': {
        'has-changes': 'There are unsaved changes in the workflow. Are you sure you want to close the builder?',
        'has-error': 'We experienced an error while saving the workflow. Are you sure you want to close the builder?',
    },
    notes: {
        add: 'Add note',
        edit: 'Edit note',
        remove: 'Remove note',
        'edited-by': 'Edited by',
        'edited-by-details': 'Edited by {details}',
        'delete-confirm': {
            title: 'Delete note',
            description: 'This note will be removed permanently. This cannot be undone.',
        },
        form: {
            title: 'Title',
            body: 'Body',
            color: 'Color',
        },
    },
    'engine-switch-blocked': 'The {engine} engine can\'t run these tasks. Remove or replace them to switch:',
    'success-response': 'Workflow has been added',
    runs: {
        search: 'Search',
        'search-by-id': 'Search by ID',
        list: {
            id: 'ID',
            name: 'Name',
            status: 'Status',
            created: 'Started at',
            duration: 'Duration',
            origin: 'Executed by',
            revision: 'Revision',
            'date-created': 'Date created',
            'clear-filters': 'Clear filters',
            workflow: 'Workflow',
        },
        actions: {
            title: 'Actions',
            cancel: 'Cancel workflow execution',
            'cancel-confirm': {
                title: 'Are you sure you want to cancel this workflow execution?',
                'title-named': 'Are you sure you want to cancel {name} execution?',
                description: 'You can\'t undo this action.',
            },
        },
        'search-by': {
            workflowId: 'Execution ID',
            recordId: 'Record ID',
            parameter: 'Parameter',
        },
        engine: {
            stable: 'Stable',
            beta: 'Beta',
        },
        details: {
            status: 'Status',
            workflow: 'Workflow',
            version: 'Version',
            origin: 'Origin',
            'started-at': 'Started at',
            duration: 'Duration',
            'show-result': 'Show result',
            refresh: 'Refresh',
            result: 'Result',
            parameters: 'Workflow parameters',
            'open-definition': 'Open workflow definition',
            'copy-id': 'Copy execution ID',
            'copy-link': 'Copy execution link',
            'id-copied': 'Execution ID copied',
            'link-copied': 'Execution link copied',
        },
        timeline: {
            case: 'Case: {name}',
            'default-case': 'Default',
            iterations: '{count} iteration | {count} iterations',
            branch: 'Branch {order}',
            loop: 'Iteration {order}',
        },
        instructions: {
            INVOKE: 'Task',
            DECIDE: 'Decision',
            FORK: 'Fork',
            LOOP: 'Loop',
        },
        'empty-filtered-list': 'No workflows have been run yet',
    },
    'run-workflow': {
        trigger: 'Run Workflow',
        again: 'Run Workflow again',
        cancel: 'Cancel',
        modal: {
            title: 'Run Workflow',
            description: {
                case: 'Select the workflow that you want to use for this case',
                onboarding: 'The workflow will be launched in a new tab and you will be able to check its results in the workflow executions tab',
                monitoring: 'The workflow will run in the background and you will be able to check its results in the workflow executions tab',
            },
            'title-with-name': 'Run workflow "{name}"',
            'running-title': 'Running Workflow...',
            'please-wait': 'Please wait',
        },
        success: {
            title: 'Success!',
            description: 'Everything went well and the case has been updated correctly.',
        },
        fail: {
            description: 'Workflow execution failed.',
        },
    },
}
